import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  filterDataAPIv1
} from "../../../services/CRUDServices"

export const filterBags = createAsyncThunk("filterData", async (body: any) => {
  console.log(body)
  const data = await filterDataAPIv1(
    "/core-api/bags/search",
    {
      ...body,
      pageNumber: undefined,
      pageSize: undefined,
    },
    body.pageNumber,
    body.pageSize,
    [
      {
        property: "id",
        direction: "DESC",
      },
    ]
  )

  // try {
  //   data = await filterTableDataAPI(filterUrls.bag as any, body?.pageNumber || 1,{
  //     ...body,
  //     pageNumber: undefined,
  //     pageSize: undefined,
  //   },true);
  //   } catch (error) {
  //     ErrorAlert(error?.response?.data?.errors?.message)
  //   }

  return data.data.response
})

const initialState: any = {
  bagsData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const BagsLists = createSlice({
  initialState: initialState,
  name: "filterData",
  reducers: {
    clearBag: (state) => {
      state.bagsData = []
    },
    setFilter: (state, action) => {
      state.filter = action.payload
    },
  },
  extraReducers: {
    [filterBags.fulfilled as any]: (state, action) => {
      console.log(action.payload)
      state.bagsData = action.payload
      state.fetchPost = false
    },
    [filterBags.pending as any]: (state) => {
      state.fetchPost = true
    },
    [filterBags.rejected as any]: (state) => {
      state.fetchPost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setFilter, clearBag } = BagsLists.actions
export default BagsLists.reducer
